export default __webpack_public_path__ + "static/media/slider_3.75ab0cf0.jpg";